export const internalPageMenu = [
  {
    name: "Home",
    tooltip: "Try and get the free CDN",
    href: "/",
    id: 0
  },
  {
    name: "Try Free",
    tooltip: "Register to the platform",
    href: "https://app.imgforce.com/register",
    id: 1
  },
  {
    name: "Login",
    tooltip: "Login to the platform",
    href: "https://app.imgforce.com/",
    id: 2
  }
];
